<template>
  <el-header class="my-el-header" height="auto">
    <img
      class="logo"
      src="@/assets/img/headerNav/headerlog.png"
      alt=""
      @click="goto"
    />
    <el-menu
      :default-active="activeIndex"
      class="header-menu"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="1">{{
        $t("components[0].headerNav[0]")
      }}</el-menu-item>
      <el-menu-item index="2">{{
        $t("components[0].headerNav[1]")
      }}</el-menu-item>
      <el-submenu index="3">
        <template #title>{{ $t("components[0].headerNav[2]") }}</template>
        <el-menu-item index="3-1">{{
          $t("components[0].headerNav[3]")
        }}</el-menu-item>
        <el-menu-item index="3-4">{{
          $t("components[0].headerNav[6]")
        }}</el-menu-item>
        <el-menu-item index="3-3">{{
          $t("components[0].headerNav[5]")
        }}</el-menu-item>
        <el-menu-item index="3-2">{{
          $t("components[0].headerNav[4]")
        }}</el-menu-item>
      </el-submenu>
      <el-menu-item index="4">{{
        $t("components[0].headerNav[7]")
      }}</el-menu-item>
      <el-menu-item index="5">{{
        $t("components[0].headerNav[8]")
      }}</el-menu-item>
      <el-menu-item index="7">{{
        $t("components[0].headerNav[11]")
      }}</el-menu-item>
      <el-menu-item index="6">{{
        $t("components[0].headerNav[9]")
      }}</el-menu-item>

      <el-submenu index="7" class="header-nav-item">
        <template #title>
          <img src="@/assets/img/headerNav/dq.png" alt="" class="img-flag"
        /></template>
        <el-menu-item index="7-1">EN</el-menu-item>
        <el-menu-item index="7-2">اللغة العربية</el-menu-item>
      </el-submenu>
    </el-menu>
    <div class="button my-button" @click="goShop">
      {{ $t("components[0].headerNav[10]") }}
    </div>
  </el-header>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "1", // 默认选中的菜单项
      router: {
        1: "home",
        2: "aboutous",
        "3-1": "qualityControl",
        "3-2": "inspectionReport",
        "3-3": "customizedSolution",
        "3-4": "rd",
        4: "cataLog",
        5: "cooperationCase",
        6: "control",
        7: "blog",
      },
      active: false,
    };
  },
  watch: {
    $route(to, from) {
      this.active = false;
      let path = to.path;
      path = path.substring(1);
      // window.alert(path);
      Object.keys(this.router).forEach((key) => {
        if (this.router[key] == path) {
          this.activeIndex = key;
          this.active = true;
        }
        if (path == "") {
          this.activeIndex = "1";
          this.active = true;
        }
        if (!this.active) {
          this.activeIndex = "";
        }
      });
      // 这里可以根据路由变化决定是否隐藏导航栏
      // this.activeIndex = to.path === "/about"; // 示例: 当访问 '/about' 时隐藏导航
    },
  },
  methods: {
    handleSelect(index) {
      if (index == "7-1") {
        this.$emit("changeLanguage", "en");
        return;
      } else if (index == "7-2") {
        this.$emit("changeLanguage", "alb");
        return;
      }
      if (this.activeIndex == index) return;
      this.activeIndex = index; // 更新选中的菜单项
      // 可以在这里进行路由导航等操作
      console.log(`选择了菜单: ${index}`);
      this.$router.push({
        name: this.router[index],
      });
      if (!this.active) {
        this.activeIndex = "";
      }
    },
    goShop() {
      this.$router.push({
        name: "shopHome",
      });
    },
    goto() {
      this.$router.push({
        name: "home",
      });
    },
  },
  mounted() {
    // 根据当前路由设置默认选中的菜单项
    let name = this.$route.name;
    Object.entries(this.router).forEach(([key, value]) => {
      if (value == name) {
        this.activeIndex = key;
      }
    });
  },
};
</script>

<style scoped lang="scss">
.header-menu {
  line-height: 100px; /* 调整菜单的高度 */
  margin: 0 auto;
  position: relative;
}
.el-header {
  display: flex;
  padding: 0;
  width: 100%;
  height: 100px;
  line-height: 100px;
  .el-submenu,
  .el-menu-item {
    font-family: "Roboto-Bold";
    font-size: 14px;
    color: #002552 !important;
    line-height: 100px !important;
    height: 100px !important;
  }
}
.el-submenu__title {
  line-height: 100px !important;
  height: 100px !important;
}
.logo {
  width: 82px;
  margin-left: 12.4%;
  cursor: pointer;
}
.button {
  background: #a7986d;
  width: 88px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  font-family: "Roboto-Bold";
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  margin-right: 12.4%;
  margin-top: 10px;
  padding: 0;
}
::v-deep.el-submenu .el-submenu__title {
  font-family: "Roboto-Bold";
  font-size: 14px;
  color: #002552 !important;
}
::v-deep.el-submenu.is-active .el-submenu__title {
  border-bottom: 0 !important;
  color: #a7986d !important;
}

.el-menu-item.is-active {
  color: #a7986d !important;
  border: 0 !important;
}
.header-nav-item {
  position: absolute;
  right: -250px;
}
.img-flag {
  width: 24px;
}
</style>

<style lang="scss">
.el-menu--popup-bottom-start {
  border-top: 4px solid #a7986d !important;
  transform: translateY(-20px);
}
.my-el-header {
  align-items: center;
  .el-menu.el-menu--horizontal {
    border-bottom: 0;
  }
  .el-submenu,
  .el-submenu__title,
  .el-menu-item {
    font-family: "Roboto-Bold";
    font-size: 14px;
    color: #002552 !important;
    line-height: 100px !important;
    height: 100px !important;
  }
}
</style>
